export default "__VITE_ASSET__9d84bc42__"